import React from "react";
import { CreateDrawer } from "../../components/drawer/DrawerComponent";
import { PaymentMethodsForm } from "./PaymentMethodsForm";
import { PAYMENT_METHODS } from "../../constants/strings";

export const PaymentMethods = () => {
  return (
    <div>
      <CreateDrawer title={PAYMENT_METHODS} form={<PaymentMethodsForm />} />
    </div>
  );
};
